import React, { MouseEvent } from 'react';
import Popover, { PopoverProps, PopoverOrigin as MuiPopoverOrigin } from '@material-ui/core/Popover';
import { Uds } from '../../types';

export type PopoverOrigin = MuiPopoverOrigin;

export type OcPopoverProps = Uds<
  Omit<PopoverProps, 'onClose'> & {
    onClose: (event?: MouseEvent) => void;
  }
>;

const DEFAULT_ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'center'
};

const DEFAULT_TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'center'
};

const OcPopover: React.FC<React.PropsWithChildren<OcPopoverProps>> = ({
  open,
  anchorEl,
  onClose,
  children,
  PaperProps = {},
  anchorOrigin = DEFAULT_ANCHOR_ORIGIN,
  transformOrigin = DEFAULT_TRANSFORM_ORIGIN,
  dataTest = 'oc-popover',
  ...rest
}) => (
  <Popover
    transitionDuration={150}
    open={open}
    anchorEl={anchorEl}
    onClose={onClose as PopoverProps['onClose']}
    anchorOrigin={anchorOrigin}
    transformOrigin={transformOrigin}
    data-test={dataTest}
    PaperProps={{
      square: true,
      ...PaperProps
    }}
    {...rest}
  >
    {children}
  </Popover>
);

export default OcPopover;
